import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/customer-management/driver/Slice";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { useForm } from "react-hook-form";

const Add = ({ id, setId }) => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();
  const imageFile = watch("image");



  const onSubmit = async (data) => {
    try {
      // const sendData = new FormData();
      // sendData.append("first_name", data?.first_name);
      // sendData.append("l_name", data?.l_name);
      // sendData.append("email", data?.email);
      // sendData.append("contact_no", data?.contact_no);
      // sendData.append("message", data?.message);
      // sendData.append("description", data?.description);
      // sendData.append("image", data?.image[0]);
      let response;
      // if (id) {
      //   response = await dispatch(Update({ id: id, data: sendData }));
      // } else {
      //   response = await dispatch(Create(sendData));
      // }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        await setId("");
        reset({ name: "" });
      }
    } catch (error) {
      console.error("error in Add Namee", error);
    }
  };
  return (
    <>
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  name=""
                  placeholder="First Name"
                  {...register("first_name", {
                    required: "first_name is Required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.name,
                  })}
                />
                {errors.first_name && (
                  <span className="text-danger">
                    {errors.first_name?.message}
                  </span>
                )}
              </div>

              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Email"
                  className={classNames("", { "is-invalid": errors?.email })}
                  {...register("email", {
                    required: "email is required",
                    maxLength: {
                      value: 100,
                      message: "email cannot exceed 100 characters",
                    },
                  })}
                />
                {errors?.email && (
                  <Form.Text className="text-danger">
                    {errors?.email?.message}
                  </Form.Text>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Contact No</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Subject"
                  className={classNames("", {
                    "is-invalid": errors?.contact_no,
                  })}
                  {...register("contact_no", {
                    required: "contact_no is required",
                    maxLength: {
                      value: 100,
                      message: "contact_no cannot exceed 100 characters",
                    },
                  })}
                />
                {errors?.contact_no && (
                  <Form.Text className="text-danger">
                    {errors?.contact_no?.message}
                  </Form.Text>
                )}
              </Form.Group>

              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label>Profile Photo</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.profile_photo,
                  })}
                  type="file"
                  {...register("profile_photo", {
                    // required: image_required
                    //   ? "Image is required"
                    //   : image_required,
                    required:
                      typeof getValues("profile_photo") == "string"
                        ? false
                        : " Image is required",
                    validate: async (value) => {
                      // if (typeof value !== "string") {
                      //   const fileTypes = ["jpg", "png", "jpeg"];
                      //   const fileType = value[0].name?.split(".")[1];
                      //   if (!fileTypes.includes(fileType)) {
                      //     return `please upload a valid file format. (${fileTypes})`;
                      //   }
                      // }
                    },
                  })}
                  //   {...register("image", {
                  //     validate: (value) => {
                  //       const currentImage = getValues("image");

                  //       if (
                  //         image_required &&
                  //         typeof currentImage !== "string" &&
                  //         (!value || value.length === 0)
                  //       ) {
                  //         return "Image is required";
                  //       }

                  //       return true;
                  //     },
                  //   })}
                  accept=".jpg, .jpeg, .png"
                />
                {errors.image && (
                  <span className="text-danger">{errors.profile_photo.message}</span>
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="text-center">Image Preview</Form.Label>
                {typeof getValues("profile_photo") == "string" ? (
                  <div className="image-preview-container">
                    <img
                      src={IDS.IMG_URL + getValues("profile_photo")}
                      alt="Preview"
                      className="image-preview"
                      style={{ width: "150px", height: "130px" }}
                    />
                  </div>
                ) : (
                  imageFile &&
                  imageFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </div>
                  )
                )}
              </Form.Group>
            </div>
          </div>

          <div className="form_submit_div ">
            <div className="row">
              <div className="col-lg-4 mx-auto mb-3">
                <div className="button_group">
                  <button
                    type="button"
                    className="closebtn theme_bg"
                    onClick={() => {
                      reset({ name: "" });
                      setId("");
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="addbtn"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};

export default Add;
